import { Avatar } from "@twilio-paste/avatar";

import {
  Anchor,
  Box,
  ModalBody,
  Table,
  TBody,
  Td,
  Th,
  THead,
  Tr,
} from "@twilio-paste/core";
import { UserIcon } from "@twilio-paste/icons/cjs/UserIcon";
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";
import { Menu, MenuButton, MenuItem, useMenuState } from "@twilio-paste/menu";
import { Text } from "@twilio-paste/text";
import { ReduxParticipant } from "../../store/reducers/participantsReducer";
import { Content } from "../../types";
import ConvoModal from "./ConvoModal";
import { getUsersFromTwilio } from "../../services/api";
import { ERROR_MODAL_MESSAGES } from "../../constants";
import { useEffect } from "react";
import React from "react";

interface ManageParticipantsModalProps {
  participantsCount: number;
  handleClose: () => void;
  isModalOpen: boolean;
  title: string;
  onClick: (content: Content) => void;
  participantsList: ReduxParticipant[];
  onParticipantRemove: (participant: ReduxParticipant) => void;
}

const ManageParticipantsModal: React.FC<ManageParticipantsModalProps> = (
  props: ManageParticipantsModalProps
) => {
  const menu = useMenuState({ placement: "bottom-start" });
  const [isAdmin, setIsAdmin] = React.useState(false);

  const verifyAdminUser = async () => {
    const partner = localStorage.getItem("partner");
    const loggedInUser = localStorage.getItem("username") ?? "";

    const users = await fetchUsers(partner as string);

    const usersAdmin = users.map((user: any) => {
      if (user.twilioAdmin) {
        return user.username;
      }
    });

    setIsAdmin(usersAdmin.includes(loggedInUser));
  };

  const fetchUsers = async (partner: string) => {
    try {
      const users = await getUsersFromTwilio(partner);
      return users as any;
    } catch (e) {
      setErrorData(e as any);
      setErrorToShow(ERROR_MODAL_MESSAGES.SEARCH_USERS);
    }
  };

  useEffect(() => {
    verifyAdminUser();
  }, []);

  return (
    <>
      <ConvoModal
        handleClose={() => props.handleClose()}
        isModalOpen={props.isModalOpen}
        title={props.title}
        modalBody={
          <ModalBody>
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                paddingTop: "6px",
              }}
            >
              <Box
                fontFamily="fontFamilyText"
                fontWeight="fontWeightBold"
                fontSize="fontSize30"
                lineHeight="lineHeight60"
              >
                Participantes ({props.participantsCount})
              </Box>
              {/* <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Button
                  fullWidth
                  variant="primary"
                  onClick={() => {
                    props.onClick(Content.AddWhatsApp);
                  }}
                >
                  Adicionar Participante
                </Button>
              </Box> */}
              <MenuButton {...menu} variant="secondary">
                Adicionar Participante{" "}
                <ChevronDownIcon decorative size="sizeIcon10" />
              </MenuButton>
              <Menu {...menu} aria-label="Preferences">
                {/* <MenuItem
                  {...menu}
                  onClick={() => props.onClick(Content.AddSMS)}
                >
                  SMS
                </MenuItem> */}
                <MenuItem
                  {...menu}
                  onClick={() => {
                    props.onClick(Content.AddWhatsApp);
                  }}
                >
                  WhatsApp
                </MenuItem>
                <MenuItem
                  {...menu}
                  onClick={() => {
                    props.onClick(Content.AddChat);
                  }}
                >
                  Chat
                </MenuItem>
              </Menu>
            </Box>
            <Box
              style={{
                marginTop: "12px",
                overflow: "hidden",
              }}
            >
              <Table>
                <THead hidden={true}>
                  <Tr>
                    <Th width="size10" style={{ width: "50px" }} />
                    <Th width="size40" textAlign="left" />
                    <Th textAlign="right" />
                  </Tr>
                </THead>
                <TBody>
                  {props.participantsList.length ? (
                    props.participantsList.map((user) => (
                      <Tr key={user.sid}>
                        <Td width="size20">
                          <Avatar
                            size="sizeIcon80"
                            name={
                              (user.identity ||
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                user.attributes["friendlyName"]) ??
                              "unknown"
                            }
                            icon={UserIcon}
                          />
                        </Td>
                        <Td textAlign="left">
                          <Text as="span" textAlign="left">
                            {user.type == "chat"
                              ? user.identity
                              : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                (user.attributes["friendlyName"] as string) ??
                                "unknown"}
                          </Text>
                        </Td>
                        <Td textAlign="right">
                          {isAdmin ? (
                            <Anchor
                              href="#"
                              onClick={() => props.onParticipantRemove(user)}
                            >
                              Remover
                            </Anchor>
                          ) : null}
                        </Td>
                      </Tr>
                    ))
                  ) : (
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "400px",
                      }}
                    >
                      <Box
                        style={{
                          color: "#606B85",
                        }}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            paddingBottom: "12px",
                          }}
                        >
                          <UserIcon
                            decorative={false}
                            title="Sem participantes"
                            size="sizeIcon40"
                            style={{
                              color: "#606B85",
                            }}
                          />
                        </Box>
                        <Text
                          as="p"
                          fontSize="fontSize40"
                          style={{
                            color: "#606B85",
                          }}
                        >
                          Sem participantes
                        </Text>
                      </Box>
                    </Box>
                  )}
                </TBody>
              </Table>
            </Box>
          </ModalBody>
        }
      />
    </>
  );
};

export default ManageParticipantsModal;
function setErrorData(arg0: any) {
  throw new Error("Function not implemented.");
}

function setErrorToShow(SEARCH_USERS: any) {
  throw new Error("Function not implemented.");
}
